import React, { useState } from "react";
import './VestiComponent.scss';

type VestData = {
    title: string;
    image: string;
    author: string;
    date: string;
    paragraphs: string[];
}

type Props = {
    data: VestData;
}

const VestiComponent: React.FC<Props> = ({data}) => {
    const [expnanded, setExpanded] = useState(false);

    const handleExpansion = () => {
        setExpanded(!expnanded);
    }

    return (
        <div className="one-novost-container">
            <div className="credits-container">
                <p className="author-p">{data.author}</p>
                <p className="date-p">{data.date}</p>
            </div>
            <div className="title-container">
                <h2>{data.title}</h2>
            </div>
            <div className="novost-row-container">
                <div className="image-credits-container">

                    <img src={data.image} alt="Slika vesti"/>
                    
                </div>
                <div className={"content-container" + (expnanded ? '    open' : '')}>
                    {data.paragraphs.map((paragraph, i) => (
                        <p className="content-p" key={i}>{paragraph}</p>
                    ))}
                </div>
            </div>
            <div className="read-more-btn-container">
                <button className="read-more-button" onClick={handleExpansion}>{!expnanded ? 'Više' : 'Manje'}</button>
            </div>
            <div className="credits-mobile-container">
                <p className="author-p">{data.author}</p>
                <p className="date-p">{data.date}</p>
            </div>
        </div>
    )
}

export default VestiComponent;